import * as Msdyn365 from '@msdyn365-commerce/core';
import { ensureAuthenticated } from '../utilities/is-authenticated';

/**
 * GetSearchOrdersAndDocuments Input Action
 */
export class GetSearchOrdersAndDocumentsInput implements Msdyn365.IActionInput {
    public searchInput: string;
    public userToken: string;
    constructor(searchInput: string, ctx: Msdyn365.ICreateActionContext) {
        this.userToken = ctx.requestContext.user.token;
        this.searchInput = searchInput;
    }

    public getCacheKey = () => `GetSearchOrdersAndDocuments-${this.searchInput}-${this.userToken}`;
    public getCacheObjectType = () => 'GetSearchOrdersAndDocuments';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetSearchOrdersAndDocumentsInput {
    searchInput: string;
}

export interface IGetSearchOrdersAndDocumentsResponse {
    '@odata.context'?: string;
    Documents?: IDocumentSearchResult[];
    Orders?: IOrderSearchResult[];
}

export interface IDocumentSearchResult {
    Date: string;
    DocumentId: string;
    FileSize: string;
    FindingPlace: IDocumentSearchFindingPlace[];
    Language: string;
    Name: string;
    Reference: string;
    Type: string;
}

export interface IOrderSearchResult {
    ConfirmedDate: string;
    FindingPlace: IDocumentSearchFindingPlace[];
    OrderLines: string;
    OrderNumber: string;
    PoNumber: string;
    ShipToCity: string;
    ShipToId: string;
    ShipToName: string;
    SoldToCity: string;
    SoldToName: string;
    SoldToId: string;
    Status: string;
}

export interface IDocumentSearchFindingPlace {
    Id: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetSearchOrdersAndDocumentsInput('', args);
};

async function action(
    input: GetSearchOrdersAndDocumentsInput,
    ctx: Msdyn365.IActionContext
): Promise<IGetSearchOrdersAndDocumentsResponse> {
    ensureAuthenticated(ctx);

    const response = await Msdyn365.sendRequest<IGetSearchOrdersAndDocumentsResponse>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/SearchOrdersAndDocuments(language='${ctx.requestContext.locale}',searchTerm='${input.searchInput}')`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            },
            timeout: 30000
        }
    );
    if (response.status === 200 && response.data) {
        return { ...response.data } as IGetSearchOrdersAndDocumentsResponse;
    } else {
        return {} as IGetSearchOrdersAndDocumentsResponse;
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetSearchOrdersAndDocumentsResponse>>action,
    id: 'GetSearchOrdersAndDocuments',
    input: createInput
});
